import React, { useState, useEffect } from 'react'
import axios from 'axios'
import useConfirm from '../hooks/Dialog'

const COMMAND_TIMEOUT = 15

const controlStyle = {
  position: "relative",
  zIndex: 1
}

const controlPopupStyle = {
  position: "absolute",
  marginTop: "-3.5rem",
  left: -5,
  right: -5,
  padding: 5,
  paddingTop: 60,
  zIndex: -1
}

const controlPanelStyle = {
  position: "relative",
  zIndex: 1
}

export default function RemoteControl({ facility, user }) {
  const { confirm } = useConfirm()
  const [time, setTime] = useState(0)
  const [used, setUsed] = useState(false)
  const [toggle, setToggle] = useState(false)
  const remote_enabled = user && user.permissions.includes("remote")
  const timeout = (time - facility.command_send_at) > COMMAND_TIMEOUT
  const start_enabled = (facility.remote || timeout) && facility.state === "IDL" && user && user.permissions.includes("remote")
  const stop_enabled = (facility.remote || timeout) && facility.state !== "IDL" && user && user.permissions.includes("remote_off")
  const error = (facility.remote === "ACK" || !used) ? null :
                (facility.command && timeout) ? "Timeout error" :
                (facility.remote === "NACK") ? "Command error" : null

  useEffect(() => {
    const interval = setInterval(() => setTime(Math.floor(Date.now() / 1000)), 1000)
    return () => { clearInterval(interval) }
  }, [])

  useEffect(() => {
    setToggle(false);
    setUsed(false)
  }, [facility.id])

  const showConfirmRemote = async () => {
    const on = facility.state === "IDL"
    const msg = on ? "on" : "off"
    const isConfirmed = await confirm(`Turn ${msg} facility`, `Do you want the turn ${msg} facility ${facility.name}?`)
    if (isConfirmed) {
      const command = on ? "STA" : "STO"
      try {
        await axios.post(`/api/v1/facility/${facility.id}/remote?organisation=${facility.organisation}`, { command })
        setUsed(true)
      }
      catch (error) {
        console.log(`Failed to turn ${msg} facility ${facility.name}`)
      }
    }
  }

  return (remote_enabled &&
    <div className="dropdown w-100" style={controlStyle}>
      <button
       key="report remote"
       className={"btn btn-warning dropdown-toggle mb-2 w-100 text-center" + (toggle ? " active" : "")}
       onClick={() => setToggle(!toggle)}
      >
        <span>Control</span>
      </button>
      <div className={"dropdown-menu " + (toggle && "show")} style={controlPopupStyle}>
        <div className="card shadow" style={controlPanelStyle}>
        {error ?
          <div className="alert alert-warning font-weight-bold text-center">
            <button type="button" className="close" aria-label="Close" onClick={() => setUsed(false)}>
              <span aria-hidden="true">&times;</span>
            </button>
            {error}
          </div> :
          <div className="alert alert-secondary font-weight-bold text-center">
            Remote control for {facility.name.toUpperCase()}. WARNING: Make sure the facility is safe to operate!
          </div>
        }
          <div className="btn-group w-100">
            <button
             className={"btn " + (start_enabled ? "btn-success" : "btn-light") + " mb-2 w-100 text-center"}
             onClick={start_enabled ? showConfirmRemote : () => {}}
            >
              <span>
              {(facility.command !== "STA" || timeout) ? "Start" : "Starting..."}
              </span>
            </button>
            <button
             className={"btn " + (stop_enabled ? "btn-danger" : "btn-light") + " mb-2 w-100 text-center"}
             onClick={stop_enabled ? showConfirmRemote : () => {}}
            >
              <span>
                {(facility.command !== "STO" || timeout) ? "Stop" : "Stopping..." }
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
